import type { ReactNode } from 'react'
import styles from './JobCreationBilling.module.css'
import { useLoading } from '@/hooks/loading-hooks'

export interface JobCreationBillingProps {
  isLoading: boolean
  children?: ReactNode
  testId?: string
}

export function JobCreationBilling({
  isLoading,
  children,
  testId,
}: JobCreationBillingProps) {
  const loading = useLoading(isLoading)

  return (
    <div
      className={styles.root}
      data-test={
        testId &&
        (loading ? `${testId}-submission-loading` : `${testId}-submission`)
      }
    >
      {children}
    </div>
  )
}
